import React from 'react';
import Grid from '@mui/material/Grid';

export default function BodyContainer({ children }) {
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      spacing={0}
      style={{
        width: '93%',
        margin: 'auto',
      }}
    >
      {children}
    </Grid>
  );
}
